import { render } from "./AddAlloyDarkstat.vue?vue&type=template&id=0879dbe8"
import script from "./AddAlloyDarkstat.vue?vue&type=script&lang=js"
export * from "./AddAlloyDarkstat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__